import React from 'react';
import { CircleBadge, CircleBadgeColor } from '../../../../CircleBadge';
import { Check } from 'react-bootstrap-icons';
import ReactTooltip from 'react-tooltip';

interface CompletedBadgeProps {
  id: string;
  completedDates: string[];
  columnName: string;
}
const CompletedBadge = ({
  id,
  completedDates,
  columnName,
}: CompletedBadgeProps) => {
  const child = completedDates.length > 1 ? `${completedDates.length}` : Check;
  return (
    <>
      <CircleBadge
        child={child}
        color={CircleBadgeColor.GREEN}
        dataFor={`completed-badge-${id}`}
        dataTip
      />
      <ReactTooltip id={`completed-badge-${id}`} effect="solid">
        <div className="mb-1">{`Completed ${columnName}`}</div>
        {completedDates.map((dateString, index) => (
          <div className="mb-1" key={`completed-badge-${id}-${index}`}>
            {dateString}
            <br />
          </div>
        ))}
      </ReactTooltip>
    </>
  );
};

export default CompletedBadge;
